import { useEffect } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import { getApi } from '~/@utils/api/getApi'
import { useAlert } from '~/@ui/alert/useAlert'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'
import PhoneHelpSvg from '~/@ui/_sharedSvgs/ui/PhoneHelp.svg?react'

export const CallMePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useCurrentUserData()
  const { showAlert } = useAlert()

  const isInvestorRoute = location.pathname.includes('/investor/')

  const helpCenterPath = isInvestorRoute
    ? '/investor/help-center'
    : '/vlastnik/help-center'

  const askForSupportCall = async () => {
    try {
      const { data: response } =
        await getApi().supportTicketsAppApiControllerCreateSupportTicket({
          type: 'call',
        })

      if ('success' in response) {
        showAlert(
          'success',
          'Vaša žiadosť o telefonickú pomoc bola úspešne odoslaná.'
        )
        return
      }

      throw new Error(
        'Nasatala neznáma chyba pri žiadosti o telefonickú pomoc.'
      )
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
      navigate(helpCenterPath)
    }
  }

  useEffect(() => {
    askForSupportCall()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack
      className="
        w-screen min-h-screen overflow-auto
      ">
      <Stack className="flex-row h-[70px] items-center gap-3 px-6 py-6">
        <ArrowBackIosNewOutlinedIcon
          className="mb-1 cursor-pointer"
          onClick={() => navigate(helpCenterPath)}
        />
        <Stack className="">
          <Typography className="text-base font-semibold text-zBlack200 ">
            Zavolajte mi
          </Typography>
          <Typography className="text-xs font-medium text-zGrey400">
            Centrum pomoci
          </Typography>
        </Stack>
      </Stack>

      <Stack
        className="w-full max-w-[768px] self-center p-6 pb-28 rounded-t-4d bg-zBlack200"
        sx={{ minHeight: 'calc(100vh - 70px)' }}>
        <Typography className="text-base font-bold text-zWhite200">{`Zavolajte mi na ${user?.phoneNumber || '...'}`}</Typography>

        <Stack className="items-center py-8">
          <Stack className="w-full h-[250px] justify-center items-center bg-zBlack300 rounded-4d">
            <Stack className="w-[110px] h-[110px] justify-center items-center bg-[#2d2d2f] rounded-full">
              <Stack className="w-[68px] h-[68px] justify-center items-center bg-zGrey300 rounded-full">
                <PhoneHelpSvg />
              </Stack>
            </Stack>
          </Stack>

          <Typography className="text-3d font-medium text-zGrey400 text-center mt-16">
            Čoskoro vás bude kontaktovať náš špecialista a rád vám pomôže.
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to={helpCenterPath}
            className="
              w-fit h-14 px-5 mt-16 bg-zWhite200
              text-3d font-medium text-zBlack200
            ">
            Rozumiem
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}
